import Cookies from "js-cookie";

import { getPublicNodeEnv } from "@/runtime-utils/config/public-env";

export const SUPPORT_MODE_COOKIE = "support_mode";
export const SUPPORT_TENANT_NAME_COOKIE = "support_tenant_name";
export const SUPPORT_TENANT_ID_COOKIE = "support_tenant_id";

const PUBLIC_NODE_ENV = getPublicNodeEnv();

const baseCookieOptions =
  PUBLIC_NODE_ENV === "production"
    ? {
        path: "/",
        sameSite: "none" as const,
        secure: true,
      }
    : PUBLIC_NODE_ENV === "test"
      ? {
          path: "/",
          sameSite: "none" as const,
          secure: true,
        }
      : {
          path: "/",
          sameSite: "lax" as const,
        };

export const supportCookieOptions = (expires = 1) => ({
  ...baseCookieOptions,
  expires,
});

export const isSupportMode = () =>
  typeof window !== "undefined" && Cookies.get(SUPPORT_MODE_COOKIE) === "true";

export const setSupportMode = () => {
  Cookies.set(SUPPORT_MODE_COOKIE, "true", supportCookieOptions());
};

export const setSupportTenant = ({
  tenantId,
  tenantName,
}: {
  tenantId: string;
  tenantName: string;
}) => {
  Cookies.set("tenant", tenantId, supportCookieOptions());
  Cookies.set(SUPPORT_TENANT_ID_COOKIE, tenantId, supportCookieOptions());
  Cookies.set(SUPPORT_TENANT_NAME_COOKIE, tenantName, supportCookieOptions());

  if (typeof window !== "undefined") {
    window.localStorage.setItem("tenant", tenantId);
  }
};

export const clearSupportTenant = () => {
  Cookies.remove("tenant", baseCookieOptions);
  Cookies.remove(SUPPORT_TENANT_ID_COOKIE, baseCookieOptions);
  Cookies.remove(SUPPORT_TENANT_NAME_COOKIE, baseCookieOptions);

  if (typeof window !== "undefined") {
    window.localStorage.removeItem("tenant");
  }
};

export const clearSupportMode = () => {
  clearSupportTenant();
  Cookies.remove(SUPPORT_MODE_COOKIE, baseCookieOptions);
};

export const getSupportTenantName = () =>
  Cookies.get(SUPPORT_TENANT_NAME_COOKIE) || "";
